import { useState, useEffect } from 'react';
import { getVideos } from '../api/api';

const staticVideos = [
  { id: 1, title: 'Physics Demo Class – Newton\'s Laws', videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ' },
  { id: 2, title: 'Chemistry – Periodic Table Explained', videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ' },
  { id: 3, title: 'Mathematics – Calculus Basics', videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ' },
  { id: 4, title: 'NEET Preparation Strategy 2024', videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ' },
  { id: 5, title: 'IIT-JEE Tips & Tricks', videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ' },
  { id: 6, title: 'Biology – Human Anatomy', videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ' },
];

function toEmbedUrl(url) {
  if (!url) return '';
  if (url.includes('embed')) return url;
  const match = url.match(/(?:v=|youtu\.be\/)([^&?/]+)/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : url;
}

export default function Videos() {
  const [videos, setVideos] = useState(staticVideos);

  useEffect(() => {
    getVideos()
      .then(r => { if (r.data.length) setVideos(r.data); })
      .catch(() => {});
  }, []);

  return (
    <div className="page">
      <div className="page-title">
        <h2>Demo <span>Classes</span></h2>
        <p>Watch free demo lectures from our expert faculty</p>
        <div className="gold-line" />
      </div>

      <div className="videos-grid" style={{ marginTop: '2rem' }}>
        {videos.map(v => (
          <div className="video-card" key={v.id}>
            <iframe
              src={toEmbedUrl(v.videoUrl)}
              title={v.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <div className="video-card-info">
              <h4>{v.title}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
